/**
 * Created by Abner Sui on 04/11/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Provider } from './tile-column-setting.model';
import { TileColumn, TileColumnDataType, TileColumnSetting, TileColumnConfig, TileColumnType } from '../../../../tamalelibs/models/tile-column.model';
import { BriefObject } from '../../../../tamalelibs/models/brief-object';
import { ProviderColumn, ProviderColumnType } from '../../../../tamalelibs/models/dataprovider.model';
import { Store, select } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { marketdataSelector } from '../../../../redux/reducers/marketdata.reducer';
import { dataproviderSelector } from '../../../../redux/reducers/dataprovider.reducer';
import { TileModel } from '../../../../tamalelibs/models/tile.model';
import { DashboardService } from '../../../../pages/dashboard/dashboard.service';
import { ArrayHelperService } from '../../../../tamalelibs/services/array-helper.service';
import { BriefConfig } from '../../../../widgets/widgets.model';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'tile-mdl-column-detail',
    templateUrl: './tile-mdl-column-detail.component.html',
    styleUrls: ['./tile-column-detail.component.scss']
})
export class TileMDLColumnDetailComponent implements OnInit, OnDestroy {

    @Input() config: TileColumn;
    @Input() wholeConfig: TileModel;
    @Input() briefConfig: BriefConfig;

    providerList: Array<Provider> = [];
    selectedProvider: Provider = null;
    fieldList: Array<ProviderColumn> = [];
    selectedField: ProviderColumn = null;
    parameterValueList: Array<BriefObject> = [];
    selectedParameterValue: BriefObject;
    dataTypeList: Array<BriefObject>;
    selectedDataType: BriefObject;
    displayList: Array<BriefObject> = [
        { id: '0', value: 'Date and Time' },
        { id: '1', value: 'Date Only' },
        { id: '2', value: 'Month and Year' },
        { id: '3', value: 'Year Only' }
    ];
    selectedDisplay: BriefObject;
    scaleList: Array<BriefObject> = [
        { id: '1', value: 'None' },
        { id: '2', value: 'Thousands' },
        { id: '3', value: 'Millions' },
        { id: '4', value: 'Billions' },
        { id: '5', value: 'Trillions' }
    ];
    selectedScale: BriefObject;
    decimalPlacesList: Array<BriefObject> = [
        { id: '0', value: '0' },
        { id: '1', value: '1' },
        { id: '2', value: '2' },
        { id: '3', value: '3' },
        { id: '4', value: '4' },
        { id: '5', value: '5' },
        { id: '6', value: '6' },
        { id: '7', value: '7' },
        { id: '8', value: '8' },
        { id: '9', value: '9' }
    ];
    selectedDecimalPlaces: BriefObject;
    isPercent = false;
    isRatio = false;
    multiplyBy100: boolean = null;
    isNumber = false;

    constructor(
        private _store: Store<any>,
        private _dashboardService: DashboardService,
    ) { }

    ngOnInit(): void {
        this.wholeConfig.columns.forEach(item => {
            if (item.dataType === TileColumnDataType.ENTITY && item.guid !== this.config.guid) {
                this.parameterValueList.push(new BriefObject(item.guid, item.title));
            }
        });
        this.selectedParameterValue = this.parameterValueList.find(item => item.id === this.config.config.parameterValue);
        this._store.pipe(select(marketdataSelector),
            take(1)
        ).subscribe(res => {
            res.forEach(one => {
                this.providerList.push(Provider.parseMarketdata(one));
            });
        });
        this._store.pipe(select(dataproviderSelector),
            take(1)
        ).subscribe(res => {
            res.forEach(one => {
                this.providerList.push(Provider.parseDataprovider(one));
            });
        });
        ArrayHelperService.sort(this.providerList, 'name');
        if (this.config.config.provider) {
            this.selectedProvider = this.providerList.find(item => item.id === this.config.config.provider && ((this.config.config.providerType && item.type === this.config.config.providerType) || (!item.type && !this.config.config.providerType)));
            this.fieldList = this.selectedProvider.columns;
            if (this.config.field) {
                this.selectedField = this.fieldList.find(item => item.name === this.config.field);
                if (this.isDateType(this.selectedField.type)) {
                    this.selectedDisplay = this.displayList.find(item => item.id === this.config.settings.display);
                }
            }
        }
        this.dataTypeList = this._getDataTypeList();
        this.selectedDataType = this.dataTypeList.find(item => item.id === this.config.dataType);
        this._afterDataTypeChange();
    }

    ngOnDestroy(): void {
    }

    onDataTypeChange(value) {
        this.selectedDataType = value;
        this.config.dataType = this.selectedDataType.id;
        this._afterDataTypeChange();
        this.briefConfig.feedbackSubject$.next(this.isNumber);
    }

    onDecimalPlacesChange(value) {
        this.selectedDecimalPlaces = value;
        this.config.settings.decimalPlaces = this.selectedDecimalPlaces.id;
    }

    onDisplayChange(value) {
        this.selectedDisplay = value;
        this.config.settings = new TileColumnSetting();
        this.config.settings.display = this.selectedDisplay.id;
    }

    onFieldChange(value) {
        this.selectedField = value;
        this.config.field = this.selectedField.name;
        this.dataTypeList = this._getDataTypeList();
        if (this.selectedProvider.type > 0 && this.isDateType(this.selectedField.type)) {
            if (this.config.settings && this.config.settings.display) {
                this.selectedDisplay = this.displayList.find(item => item.id === this.config.settings.display);
            } else {
                this.selectedDisplay = this.displayList[1];
                this.config.settings = new TileColumnSetting();
                this.config.settings.display = this.selectedDisplay.id;
            }
            this.selectedDataType = this.dataTypeList[0];
        } else {
            if (this.config.dataType) {
                this.selectedDataType = this.dataTypeList.find(item => item.id === this.config.dataType);
            }
            if (!this.selectedDataType) {
                this.selectedDataType = this.dataTypeList[0];
            }
        }
        this.onDataTypeChange(this.selectedDataType);
    }

    onMultipleMDLChange(value) {
        if (!this.config.config) {
            this.config.config = new TileColumnConfig();
        }
        this.config.config.isMultipleMDL = value;
        this._syncMultipleMDLValueToOther();
    }

    onMultiplyBy100Change(value) {
        this.multiplyBy100 = value;
        this.config.settings.multiplyBy100 = this.multiplyBy100;
    }

    onParameterValueChange(value) {
        this.selectedParameterValue = value;
        if (!this.config.config) {
            this.config.config = new TileColumnConfig();
        }
        this.config.config.parameterValue = this.selectedParameterValue.id;
    }

    onProviderChange(value) {
        this.selectedProvider = value;
        this.config.config.provider = this.selectedProvider.id;
        this.config.config.providerType = this.selectedProvider.type;

        this.fieldList = this.selectedProvider.columns;
        this.selectedField = null;
        delete this.config.field;
        if (this.config.config.providerType === 0) {
            delete this.config.config.isMultipleMDL;
        } else {
            this.config.config.isMultipleMDL = false;
        }
        this._syncMultipleMDLValueFromOther();
    }

    onScaleChange(value) {
        this.selectedScale = value;
        this.config.settings.scale = this.selectedScale.id;
    }

    isDateType(data) {
        return this._dashboardService.isDateType(data);
    }

    private _afterDataTypeChange() {
        if (!this.selectedDataType) {
            return;
        }
        if (this.selectedDataType.id === 'text' || this.isDateType(this.selectedDataType.id)) {
            this.isPercent = false;
            this.isRatio = false;
            this.selectedDecimalPlaces = null;
            this.selectedScale = null;
            this.multiplyBy100 = null;
            this.isNumber = false;
            if (this.config.settings) {
                const tempSettings = new TileColumnSetting();
                if (this.config.settings.display) {
                    tempSettings.display = this.config.settings.display;
                }
                this.config.settings = tempSettings;
            }
        } else {
            this.isNumber = true;
            if (!this.config.settings) {
                this.config.settings = new TileColumnSetting();
            }
            if (!this.config.settings.negatives) {
                this.config.settings.negatives = 1;
            }
            if (this.config.settings.decimalPlaces) {
                this.selectedDecimalPlaces = this.decimalPlacesList.find(item => item.id === this.config.settings.decimalPlaces);
            } else {
                this.selectedDecimalPlaces = this.decimalPlacesList[2];
                this.config.settings.decimalPlaces = this.selectedDecimalPlaces.id;
            }
            if (this.selectedDataType.id === TileColumnDataType.PERCENT) {
                if (this.config.settings.multiplyBy100 !== null && this.config.settings.multiplyBy100 !== undefined) {
                    this.multiplyBy100 = this.config.settings.multiplyBy100;
                } else {
                    this.multiplyBy100 = true;
                    this.config.settings.multiplyBy100 = this.multiplyBy100;
                }
                this.isPercent = true;

                this.isRatio = false;
                this._clearScale();
            } else if (this.selectedDataType.id === TileColumnDataType.RATIO) {
                this.isRatio = true;

                this.isPercent = false;
                this._clearScale();
                this._clearMultiplyBy100();
            } else {
                if (this.config.settings.scale) {
                    this.selectedScale = this.scaleList.find(item => item.id === this.config.settings.scale);
                } else {
                    this.selectedScale = this.scaleList[0];
                    this.config.settings.scale = this.selectedScale.id;
                }

                this.isPercent = false;
                this.isRatio = false;
                this._clearMultiplyBy100();
            }
        }
    }

    private _clearMultiplyBy100() {
        this.multiplyBy100 = null;
        if (this.config.settings && this.config.settings.multiplyBy100 !== null && this.config.settings.multiplyBy100 !== undefined) {
            delete this.config.settings.multiplyBy100;
        }
    }

    private _clearScale() {
        this.selectedScale = null;
        if (this.config.settings && this.config.settings.scale) {
            delete this.config.settings.scale;
        }
    }

    private _getDataTypeList(): Array<BriefObject> {
        let result: Array<BriefObject> = [];
        if (this.selectedProvider && this.selectedField) {
            const providerType: number = this.selectedProvider.type;
            const fieldType: ProviderColumnType = this.selectedField.type;
            const dateCondition = fieldType === ProviderColumnType.TIMESTAMP_WITH_TIME_ZONE ||
                fieldType === ProviderColumnType.TIMESTAMP ||
                fieldType === ProviderColumnType.TIME ||
                fieldType === ProviderColumnType.BYTEA;

            if (providerType > 0 && fieldType === ProviderColumnType.STRING) {
                result = [
                    { id: 'text', value: 'Text' }
                ];
            } else if (providerType > 0 && fieldType === ProviderColumnType.NUMBER) {
                result = [
                    { id: 'number', value: 'Number' },
                    { id: 'currency', value: 'Currency' },
                    { id: 'percent', value: 'Percent' },
                    { id: 'ratio', value: 'Ratio' }
                ];
            } else if (providerType > 0 && fieldType === ProviderColumnType.DATE) {
                result = [
                    { id: 'date', value: 'Date' },
                ];
            } else if (providerType === 0) {
                result = [
                    { id: 'text', value: 'Text' },
                    { id: 'date', value: 'Date' },
                    { id: 'number', value: 'Number' },
                    { id: 'currency', value: 'Currency' },
                    { id: 'percent', value: 'Percent' },
                    { id: 'ratio', value: 'Ratio' }
                ];
            } else if (dateCondition) {
                result = [
                    { id: fieldType, value: 'Date' },
                ];
            }
        }
        return result;
    }

    private _syncMultipleMDLValueToOther(): void {
        if (this.config.config && this.config.config.provider && this.config.config.providerType) {
            this.wholeConfig.columns.forEach(item => {
                if (item.columnType === TileColumnType.MDL_COLUMN && item.guid !== this.config.guid
                    && item.config && item.config.provider === this.config.config.provider
                    && item.config.providerType === this.config.config.providerType) {
                    item.config.isMultipleMDL = this.config.config.isMultipleMDL;
                }
            });
        }
    }

    private _syncMultipleMDLValueFromOther(): void {
        if (this.config.config && this.config.config.provider && this.config.config.providerType) {
            const tempLength = this.wholeConfig.columns.length;
            for (let i = 0; i < tempLength; i++) {
                const item: TileColumn = this.wholeConfig.columns[i];
                if (item.columnType === TileColumnType.MDL_COLUMN && item.guid !== this.config.guid
                    && item.config && item.config.provider === this.config.config.provider
                    && item.config.providerType === this.config.config.providerType) {
                    if (!this.config.config) {
                        this.config.config = new TileColumnConfig();
                    }
                    this.config.config.isMultipleMDL = item.config.isMultipleMDL;
                    break;
                }
            }
        }
    }

}
